import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Plugins } from "@capacitor/core";
import { ModalController } from "@ionic/angular";
import { cnpj } from "cpf-cnpj-validator";
import { IonicSelectableComponent } from "ionic-selectable";
import { Consultor } from "src/app/models/consultores.model";
import { ConsultoresService } from "src/app/services/consultores.service";
import { environment } from "src/environments/environment";

const { Toast, Modals } = Plugins;
declare var Email;

@Component({
  selector: "app-consultores-modal",
  templateUrl: "./consultores-modal.page.html",
  styleUrls: ["./consultores-modal.page.scss"],
})
export class ConsultoresModalPage implements OnInit {
  @ViewChild("") elemento: string;
  @ViewChild("pwaphoto") pwaphoto: ElementRef;
  @Input() type: string;
  @Input() consultor: Consultor;

  imgURI: string = null;

  modoEditar: boolean = false;
  formConsultor: FormGroup;
  mensagens: any;
  estados: Array<any>;
  cidades: any[] = [];

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private service: ConsultoresService,
    private http: HttpClient
  ) {
    this.estados = [];
  }

  ngOnInit() {
    this.formulario();
    this.inicializaEstados();
    this.inicializaValidators();
  }

  formulario() {
    this.formConsultor = this.formBuilder.group({
      nome_fantasia: new FormControl("", Validators.required),
      cnpj: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.minLength(18)])
      ),
      email: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
        ])
      ),
      cidade: new FormControl("", Validators.required),
      estado: new FormControl("", Validators.required),
      celular: new FormControl("", Validators.required),
      telefone: new FormControl(""),
      endereco: new FormControl("", Validators.required),
      logo: new FormControl(""),
      ativa: new FormControl(false),
      origem: new FormControl("Empresarial"),
      role: new FormControl("consultor"),
    });

    if (this.type === "editar") {
      this.modoEditar = true;
      this.formConsultor
        .get("nome_fantasia")
        .setValue(this.consultor.nome_fantasia);
      this.formConsultor.get("cnpj").setValue(this.consultor.cnpj);
      this.formConsultor.get("email").setValue(this.consultor.email);
      this.formConsultor.get("cidade").setValue(this.consultor.cidade);
      this.formConsultor.get("estado").setValue(this.consultor.estado);
      this.formConsultor.get("telefone").setValue(this.consultor.telefone);
      this.formConsultor.get("celular").setValue(this.consultor.celular);
      this.formConsultor.get("endereco").setValue(this.consultor.endereco);
      this.formConsultor.get("logo").setValue(this.consultor.logo);
    }
  }

  editar(consultor: Consultor) {
    consultor.ativa = true;
    const cnpj = consultor.cnpj.toString().replace(/\D/g, "");
    const updatedConsultor = new Consultor().deserialize({
      ...this.consultor,
      ...consultor,
    });

    this.validarCnpj(cnpj).then(
      async (success) => {
        if (success && success === true) {
          this.service.edit(updatedConsultor).subscribe(
            async () => {
              await Toast.show({
                text: `${consultor.nome_fantasia} atualizada.`,
                duration: "long",
              });
            },
            async (erro) => {
              await Modals.alert({
                title: "Erro",
                message: `${erro.error.message}`,
              });
            },
            () => {
              this.fecharJanela();
            }
          );
        } else {
          await Toast.show({
            text: "CNPJ inválido! Verifique e tente novamente.",
            duration: "long",
            position: "bottom",
          });
        }
      },
      async (error) => {
        await Modals.alert({
          title: "Erro",
          message: `${error.error.message}`,
        });
      }
    );
  }

  enviaEmail(consultor: Consultor) {
    try {
    } catch (error) {}
    this.http
      .post(environment.sendEmail, {
        to: consultor.email,
        subject: "Cadastro Cartão PASS",
        html: `<h3>Sejá bem vindo ao time do Cartão PASS!</h3><br/>
      Acesse a área do parceiro em  http://cartaopass.com.br/<br/>
      Login: ${consultor.email}<br/>
      Senha: ${consultor.cnpj.replace(/[./]/g, "")}`,
      })
      .subscribe((data: any) => {
        if (data.status === 200) {
          alert(
            "Email com login enviado com sucesso! Informar cliente para verificar caixa de spam"
          );
        } else {
          alert(data.message);
        }
      });
  }

  salvar(consultor: Consultor) {
    const cnpj = consultor.cnpj.toString().replace(/\D/g, "");

    this.validarCnpj(cnpj).then(
      async (success) => {
        if (success && success === true) {
          let password = cnpj;
          consultor.password = password;

          this.service.create(consultor).subscribe(
            async () => {
              await Toast.show({
                text: `Novo consultor ${consultor.nome_fantasia} criado.`,
                duration: "long",
              });
              this.enviaEmail(consultor);
              this.fecharJanela();
            },
            (error) => {
              if (error.status === 500) {
                this.http
                  .patch(
                    `${environment.rotaConsultores}/atualizaConsultor/${cnpj}`,
                    consultor
                  )
                  .subscribe(
                    async () => {
                      await Toast.show({
                        text: `Informações salvas com sucesso.`,
                        duration: "long",
                        position: "top",
                      });
                      this.enviaEmail(consultor);
                    },
                    async (error) => {
                      await Toast.show({
                        text: `Não foi possível realizar as alterações. Código do erro: ${error.message}`,
                        duration: "long",
                        position: "top",
                      });
                    },
                    () => {
                      this.fecharJanela();
                    }
                  );
              }
            },
            () => {
              this.fecharJanela();
            }
          );
        } else {
          await Toast.show({
            text: "CNPJ inválido! Verifique e tente novamente.",
            duration: "long",
            position: "bottom",
          });
        }
      },
      async (error) => {
        await Modals.alert({
          title: "Erro",
          message: `${error.error.message}`,
        });
      }
    );
  }

  async validarCnpj(dado: any) {
    return cnpj.isValid(dado);
  }

  async inicializaEstados() {
    fetch("./../../../assets/estados.json")
      .then((dados) => dados.json())
      .then((data) => {
        this.estados = data;
      });
  }

  estadosOnChange(evento: { component: IonicSelectableComponent; value: any }) {
    this.formConsultor.get("cidade").reset();
    if (evento.value) {
      this.estados.filter((estado) => {
        if (estado.sigla === evento.value) {
          this.cidades = estado.cidades;
        }
      });
    }
  }

  openPWAPhotoPicker() {
    if (this.pwaphoto == null) {
      return;
    }

    this.pwaphoto.nativeElement.click();
  }

  uploadPWA() {
    if (this.pwaphoto == null) {
      return;
    }

    const fileList: FileList = this.pwaphoto.nativeElement.files;

    if (fileList && fileList.length > 0) {
      this.firstFileToBase64(fileList[0]).then(
        (result: string) => {
          this.imgURI = result;
          this.formConsultor.get("logo").setValue(this.imgURI);
        },
        (err: any) => {
          // Ignore error, do nothing
          this.imgURI = null;
        }
      );
    }
  }

  private firstFileToBase64(fileImage: File): Promise<{}> {
    return new Promise((resolve, reject) => {
      let fileReader: FileReader = new FileReader();
      if (fileReader && fileImage != null) {
        fileReader.readAsDataURL(fileImage);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      } else {
        reject(new Error("No file found"));
      }
    });
  }

  fecharJanela() {
    this.modalCtrl.dismiss({
      dissmissed: true,
    });
  }

  inicializaValidators() {
    this.mensagens = {
      nome: [
        {
          type: "required",
          message: "Insira um nome!",
        },
      ],
      email: [
        {
          type: "required",
          message: "Insira um e-mail!",
        },
        {
          type: "pattern",
          message: "Insira um e-mail válido!",
        },
      ],
      nascimento: [
        {
          type: "required",
          message: "Insira a data de nascimento!",
        },
      ],
      endereco: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
        {
          type: "minlength",
          message: "No mínimo 10 cararteres.",
        },
      ],
      cidade: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
      ],
      estado: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
      ],
      documentoRg: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
      ],
      documentoCpf: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
        {
          type: "minlength",
          message: "Um CPF válido precisa conter 11 caracteres.",
        },
      ],
      celular: [
        {
          type: "required",
          message: "Este campo é obrigatório.",
        },
      ],
    };
  }
}
